<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-9">
                    <card>
                        <h5 slot="header" class="card-title"><span @click="goBack()" class="link">Назад</span> -
                            Общая информация</h5>
                        <div class="loader" v-if="waiting"></div>

                        <form v-if="template">
                            <div class="row">

                                <div class="col-md-4">
                                    <fg-input type="text"
                                              label="Название шаблона"
                                              v-model="template.name"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Тип шаблона</label>
                                        <select v-model="template.type"
                                                id="type-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="1">1. По дате: прошлая неделя</option>
                                            <option value="2">2. По дате: прошлый месяц</option>
                                            <option value="3">3. По дате: текущий месяц</option>
                                            <option value="4">4. По дате: прошлый год</option>
                                            <option value="5">5. По дате: текущий год</option>
                                            <option value="6">6. По дате: прошлые выходные</option>
                                            <option value="7">7. По дате: будние дни на прошлой неделе</option>
                                            <option value="8">8. По дате: Лето</option>
                                            <option value="9">9. По дате: Осень</option>
                                            <option value="10">10. По дате: Зима</option>
                                            <option value="11">11. По дате: Весна</option>
                                            <option value="12">12. По дате: Лето прошлого года</option>
                                            <option value="13">13. По дате: Осень прошлого года</option>
                                            <option value="14">14. По дате: Зима прошлого года</option>
                                            <option value="15">15. По дате: Весна прошлого года</option>
                                            <option value="16">16. По местоположению: Путешествие</option>
                                            <option value="17">17. По местоположению: Дом</option>
                                            <option value="18">18. One day of my life</option>
                                            <option value="19">19. Recently</option>
                                            <option value="20">20. Day of my life with date</option>
                                            <option value="21">21. Spring Camera Roll</option>
                                            <option value="22">22. Spring Recap</option>
                                            <option value="23">23. По дате: за последние 6 месяцев</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="template.status"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="1">Опубликовано</option>
                                            <option value="0">Ожидает</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Анимированный тип шаблона</label>
                                        <select v-model="template.format_type"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="0">Обычный</option>
                                            <option value="1">Slide 2 кусочка (справа-налево)</option>
                                            <option value="2">Slide 3 кусочка (справа-налево)</option>
                                            <option value="3">Slide 2 кусочка (снизу-вверх)</option>
                                            <option value="4">Slide 3 кусочка (снизу-вверх)</option>
                                            <option value="5">Slide слева вниз, справа вверх</option>
                                            <option value="6">Разъезжается центральный кадр</option>
                                            <option value="7">Slide 2 кусочка (слева-направо)</option>
                                            <option value="8">Slide 3 кусочка (слева-направо)</option>
                                            <option value="9">Slide 2 кусочка (сверху-вниз)</option>
                                            <option value="10">Slide 3 кусочка (сверху-вниз)</option>
                                            <option value="11">Разъезжается первый кадр</option>
                                            <option value="12">Появляются по очереди 3 кусочка и уезжают вверх</option>
                                            <option value="13">Cutout (смешанный)</option>
                                            <option value="14">14</option>
                                            <option value="15">15</option>
                                            <option value="16">16</option>
                                            <option value="17">17</option>
                                            <option value="18">18</option>
                                            <option value="19">19</option>
                                            <option value="20">20</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Минимальная версия</label>
                                        <select v-model="template.v" class="form-control">
                                            <option value="">Все версии</option>
                                            <option
                                                v-for="version in versions"
                                                :key="version"
                                                :value="version"
                                            >
                                                {{ version }}
                                            </option>
                                        </select>
                                    </div>
                                    <fg-input type="text"
                                              label="Сортировка (чем больше, тем выше в списке)"
                                              v-model="template.sort"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Название трека"
                                              v-model="template.song"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text" v-if="template.is_copyrighted"
                                              label="Ссылка на Reels audio"
                                              v-model="template.song_insta"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text" v-if="template.is_copyrighted"
                                              label="Ссылка на TikTok audio"
                                              v-model="template.song_tiktok"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="date"
                                              label="Дата публикации (формат ДД.ММ.ГГГГ)"
                                              v-model="template.release_date"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="time" v-if="template.release_date"
                                              label="Время публикации (формат HH:MM)"
                                              v-model="template.release_time"
                                              placeholder="">
                                    </fg-input>
                                </div>


                                <div class="col-md-3 checkbox-block">
                                    <div class="form-group">
                                        <label for="premium-control"
                                               class="control-label label-checkbox">Премиум</label>
                                        <input v-model="template.is_premium" id="premium-control"
                                               class="form-check-inline" type="checkbox">
                                    </div>
                                    <div class="form-group">
                                        <label for="new-control"
                                               class="control-label label-checkbox">Новое</label>
                                        <input v-model="template.is_new" id="new-control"
                                               class="form-check-inline"
                                               type="checkbox">
                                    </div>
                                    <div class="form-group">
                                        <label for="copyrighted-control" class="control-label label-checkbox">Copyrighted-музыка</label>
                                        <input v-model="template.is_copyrighted" id="copyrighted-control"
                                               class="form-check-inline" type="checkbox">
                                    </div>
                                    <div class="form-group">
                                        <label for="text-control" class="control-label label-checkbox">Наложение
                                            текста/объекта</label>
                                        <input v-model="is_text_active" @change="toggleText()" id="text-control"
                                               class="form-check-inline"
                                               type="checkbox">
                                    </div>
                                </div>


                                <div class="col-md-4">
                                    <div class="margin-top">
                                        <h5 slot="header" class="card-title">
                                            Видео: <span v-if="template.preview_src_full">
                                            <span class="inline-link">
                                                <span v-if="template.preview_src_size >= 1"
                                                      class="bg-danger">{{ template.preview_src_size }}Mb</span>
                                                <span v-else-if="template.preview_src_size >= 0.5"
                                                      class="bg-warning">{{ template.preview_src_size }}Mb</span>
                                                <span v-else>{{ template.preview_src_size }}Mb</span>
                                                <a :href="template.preview_src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                        </h5>

                                        <div>
                                            <input ref="previewFileInput" class="btn-file" type="file"
                                                   @change="uploadFile($event, 'preview_src')">
                                            <button type="button" class="btn btn-info btn-fill upload-button"
                                                    @click="$refs.previewFileInput.click()">
                                                Загрузить
                                            </button>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                    <div class="margin-top">
                                        <h5 slot="header" class="card-title">
                                            Аудио: <span v-if="template.audio_full">
                                            <span class="inline-link">
                                                <span v-if="template.audio_size >= 1"
                                                      class="bg-danger">{{ template.audio_size }}Mb</span>
                                                <span v-else-if="template.audio_size >= 0.5"
                                                      class="bg-warning">{{ template.audio_size }}Mb</span>
                                                <span v-else>{{ template.audio_size }}Mb</span>
                                                <a :href="template.audio_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                        </h5>

                                        <div>
                                            <input ref="audioFileInput" class="btn-file" type="file"
                                                   accept="audio/mp3"
                                                   @change="uploadFile($event, 'audio')">
                                            <button type="button" class="btn btn-info btn-fill upload-button"
                                                    @click="$refs.audioFileInput.click()">
                                                Загрузить
                                            </button>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="text-center">
                                <button type="submit" class="btn btn-success btn-fill float-right btn-save"
                                        :disabled="!template.videos || !template.type || !template.name
                                        || !template.song || !template.audio || !template.preview_src
                                        || (template.is_copyrighted === true && (!template.song_insta && !template.song_tiktok))"
                                        @click.prevent="save">
                                    Сохранить
                                </button>
                            </div>
                            <div class="clearfix"></div>
                        </form>
                    </card>

                    <!--"888"-->
                    <div class="modal-mask" v-if="show_collage_modal" @click="closeCollageModal">
                        <div class="modal-wrapper">
                            <div class="modal-container">

                                <div class="modal-header">
                                    <slot name="header">
                                        <button v-for="(t, index) in collages"
                                                type="button" class="btn btn-text btn-fill collage-category"
                                                :class="{ 'active' : t.name === active_collage_category}"
                                                @click="selectCollageCategory(t.name)">
                                            {{ t.name }}
                                        </button>
                                    </slot>
                                </div>

                                <div class="modal-body">
                                    <slot ref="collage" name="body">
                                        <div v-for="(t, index) in collages">
                                            <div v-for="(c, index) in t.data"
                                                 v-if="t.name === active_collage_category"
                                                 class="collage-item" >
                                                <div @click="addCollage" v-html="renderCollage(c)"></div>

                                            </div>
                                        </div>
                                    </slot>
                                </div>

                                <div class="modal-footer">
                                    <slot name="footer">
                                        <button class="btn btn-info btn-fill modal-close-button"
                                                @click="closeCollageModal">
                                            Закрыть
                                        </button>
                                    </slot>
                                </div>
                            </div>
                        </div>
                    </div>

                    <card v-show="is_text_active">

                        <h4 slot="header" class="card-title">
                            Текст</h4>

                        <div class="texts-buttons" v-if="is_text_active">
                            <button v-for="(t, index) in template.texts"
                                    type="button" class="btn btn-text btn-fill"
                                    :class="{ 'active' : index === active_text && active_type === 'text'}"
                                    @click="selectText(index)">{{ t.text }}
                                <span class="animated-icon" v-if="t.animation_type !== 0">•</span>
                            </button>
                            <button v-for="(t, index) in template.objects"
                                    type="button" class="btn btn-text btn-fill"
                                    :class="{ 'active' : index === active_object && active_type === 'object'}"
                                    @click="selectObject(index)">
                                <img alt="" class="button-preview"
                                     :style="{ backgroundImage: 'url(\'' + objectPlayerSrc(t) + '\')' }">
                                <span class="animated-icon" v-if="t.animation_type !== 0">•</span>
                            </button>
                            <button type="button" class="btn btn-text btn-fill active control-btn"
                                    @click="active_type === 'text' ? addText(active_text) : addObject(null, active_object)">
                                Копировать
                            </button>
                            <button type="button" class="btn btn-text btn-fill active control-btn"
                                    @click="addText()">Добавить текст
                            </button>
                            <button type="button" class="btn btn-text btn-fill active control-btn"
                                    @click="showSVGModal()">Добавить объект
                            </button>
                        </div>

                        <div class="modal-mask" v-if="show_svg_modal" @click="closeSVGModal">
                            <div class="modal-wrapper">
                                <div class="modal-container">

                                    <div class="modal-header">
                                        <slot name="header">
                                            <button v-for="(t, index) in server_graphics"
                                                    type="button" class="btn btn-text btn-fill"
                                                    :class="{ 'active' : t.name === active_object_category}"
                                                    @click="selectObjectCategory(t.name)">
                                                {{ t.name }}
                                            </button>
                                        </slot>
                                    </div>

                                    <div class="modal-body">
                                        <slot name="body">
                                            <div v-for="(t, index) in server_graphics">
                                                <div v-for="(c, index) in t.data"
                                                     v-if="t.name === active_object_category"
                                                     class="object-item"
                                                     @click="addObject(c)">
                                                    <img :src="`${graphicsUrl}${c.src}`" class="image">
                                                </div>
                                            </div>
                                        </slot>
                                    </div>

                                    <div class="modal-footer">
                                        <slot name="footer">
                                            <button class="btn btn-info btn-fill modal-close-button"
                                                    @click="closeSVGModal">
                                                Закрыть
                                            </button>
                                        </slot>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <form>
                            <div class="loader" v-if="waiting"></div>

                            <div class="row">
                                <div class="col-md-4 c-labels" v-if="is_text_active && active_type === 'text'">
                                    <label class="control-label">Текст</label>
                                    <textarea class="text-area"
                                              v-model="template.texts[active_text].text">
                                    </textarea>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <fg-input type="text"
                                                      label="Время появления текста (0 - c начала)"
                                                      v-model="template.texts[active_text].time_start"
                                                      placeholder="">
                                            </fg-input>
                                        </div>
                                        <div class="col-md-6">
                                            <fg-input type="text"
                                                      label="Время исчезновения (пустое - до конца)"
                                                      v-model="template.texts[active_text].time_end"
                                                      placeholder="">
                                            </fg-input>
                                        </div>
                                    </div>
                                    <label class="control-label">Размер шрифта: <span
                                        class="param-span">{{ template.texts[active_text].font_size }}</span></label>
                                    <fg-input type="range"
                                              min="5" max="200" step="1"
                                              label=""
                                              v-model="template.texts[active_text].font_size"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Шрифт</label>
                                        <select v-model="template.texts[active_text].font_name"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="f in sortedFonts" v-bind:value="f.name">{{ f.name }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label for="control1" class="control-label label-checkbox">По центру по
                                            горизонтали</label>
                                        <input @change="setTextPosition(0.5, null)"
                                               :checked="template.texts[active_text].position_x == 0.5"
                                               id="control1" class="form-check-inline"
                                               type="checkbox">
                                        <fg-input type="text"
                                                  label="Position X"
                                                  @input="val => setTextPosition(val, null)"
                                                  v-model="template.texts[active_text].position_x"
                                                  placeholder="">
                                        </fg-input>
                                        <div class="clearfix"></div>
                                        <label for="control2" class="control-label label-checkbox">По центру по
                                            вертикали</label>
                                        <input @change="setTextPosition(null, 0.5)"
                                               :checked="template.texts[active_text].position_y == 0.5"
                                               id="control2" class="form-check-inline"
                                               type="checkbox">
                                        <fg-input type="text"
                                                  label="Position Y"
                                                  @input="val => setTextPosition(null, val)"
                                                  v-model="template.texts[active_text].position_y"
                                                  placeholder="">
                                        </fg-input>
                                    </div>
                                    <div class="form-group">
                                        <label for="control1" class="control-label label-checkbox mb10">Text brush</label>
                                        <input v-model="template.texts[active_text].is_text_brush"
                                               id="control1" class="form-check-inline"
                                               type="checkbox">
                                        <div class="clearfix"></div>
                                        <label class="control-label" v-if="template.texts[active_text].is_text_brush">Text brush data</label>
                                        <textarea class="text-area" v-if="template.texts[active_text].is_text_brush"
                                                  v-model="template.texts[active_text].text_brush_data">
                                    </textarea>
                                    </div>
                                    <fg-input type="text"
                                              label="Поворот текста (градусы)"
                                              v-model="template.texts[active_text].angle"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Межбуквенный интервал"
                                              v-model="template.texts[active_text].letter_spacing"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Межстрочный интервал"
                                              v-model="template.texts[active_text].line_spacing"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Цвет текста: <span class="param-span">{{
                                                template.texts[active_text].text_color
                                            }}</span></label>
                                        <input type="color" v-model="template.texts[active_text].text_color">
                                        <div class="color-set">
                                            <span v-for="c in colors" :style="{ backgroundColor: c }"
                                                  :class="{ 'active' : c === template.texts[active_text].text_color}"
                                                  @click="setColor(c, 'color')"></span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Цвет фона:
                                            <span class="param-span"
                                                  v-if="template.texts[active_text].background_color === 'transparent'">Прозрачный</span>
                                            <span class="param-span"
                                                  v-else>{{ template.texts[active_text].background_color }}</span>
                                        </label>
                                        <input type="color" v-model="template.texts[active_text].background_color"
                                               v-show="template.texts[active_text].background_color !== 'transparent'">
                                        <div class="clearfix"></div>
                                        <label for="background-control" class="control-label label-checkbox mb10">Прозрачный</label>
                                        <input @change="toggleBackground()"
                                               :checked="template.texts[active_text].background_color === 'transparent'"
                                               id="background-control" class="form-check-inline"
                                               type="checkbox">
                                        <div class="color-set"
                                             v-show="template.texts[active_text].background_color !== 'transparent'">
                                            <span v-for="c in colors" :style="{ backgroundColor: c }"
                                                  :class="{ 'active' : c === template.texts[active_text].background_color}"
                                                  @click="setColor(c, 'background')"></span>
                                        </div>
                                    </div>
                                    <label class="control-label">Видимость: <span
                                        class="param-span">{{ template.texts[active_text].alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.texts[active_text].alpha"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Направление текста</label>
                                        <select v-model="template.texts[active_text].direction"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="normal">normal</option>
                                            <option value="vertical">vertical</option>
                                            <option value="round">round</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Анимация</label>
                                        <select v-model="template.texts[active_text].animation_type"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="t in animation_types" v-bind:value="t.id">{{
                                                    t.name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                    <label v-show="template.texts[active_text].animation_type !== 0"
                                           class="control-label">Длительность анимации: <span
                                        class="param-span">{{
                                            template.texts[active_text].animation_duration
                                        }} сек</span></label>
                                    <fg-input v-show="template.texts[active_text].animation_type !== 0" type="range"
                                              min="0" max="20" step="0.1"
                                              label=""
                                              v-model="template.texts[active_text].animation_duration"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Выравнивание <br>(если больше одной строки)</label>
                                        <select v-model="template.texts[active_text].text_align"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="ta in text_aligns" v-bind:value="ta.name">{{
                                                    ta.name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                    <label for="shadow-color">Цвет тени:</label>
                                    <input type="color" id="shadow-color"
                                           v-model="template.texts[active_text].shadow_color">
                                    <div class="clearfix"></div>
                                    <label class="control-label">Радиус размытия тени: <span
                                        class="param-span">{{ template.texts[active_text].shadow_blur }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="100" step="1"
                                              label=""
                                              v-model="template.texts[active_text].shadow_blur"
                                              placeholder="">
                                    </fg-input>
                                    <label class="control-label">Видимость тени: <span
                                        class="param-span">{{ template.texts[active_text].shadow_alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.texts[active_text].shadow_alpha"
                                              placeholder="">
                                    </fg-input>
                                    <label class="control-label">Размер обводки: <span
                                        class="param-span">{{ template.texts[active_text].stroke_size }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="100" step="1"
                                              label=""
                                              v-model="template.texts[active_text].stroke_size"
                                              placeholder="">
                                    </fg-input>
                                    <label for="stroke-color">Цвет обводки:</label>
                                    <input type="color" id="stroke-color"
                                           v-model="template.texts[active_text].stroke_color">
                                    <div class="clearfix"></div>

                                    <fg-input type="text"
                                              label="Z-индекс"
                                              v-model="template.texts[active_text].z_index"
                                              placeholder="">
                                    </fg-input>

                                    <button type="button" class="btn btn-remove"
                                            @click="removeText(active_text)">Удалить текст
                                    </button>
                                    <div class="clearfix"></div>

                                </div>


                                <div class="col-md-4 c-labels" v-if="is_text_active && active_type === 'object'">
                                    <label class="control-label">Объект</label>
                                    <img alt="" @click="changeObject()" class="object-preview"
                                         :src="objectPlayerSrc(template.objects[active_object])">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <fg-input type="text"
                                                      label="Время появления объекта (0 - c начала)"
                                                      v-model="template.objects[active_object].time_start"
                                                      placeholder="">
                                            </fg-input>
                                        </div>
                                        <div class="col-md-6">
                                            <fg-input type="text"
                                                      label="Время исчезновения (пустое - до конца)"
                                                      v-model="template.objects[active_object].time_end"
                                                      placeholder="">
                                            </fg-input>
                                        </div>
                                    </div>
                                    <label class="control-label">Размер: <span
                                        class="param-span">{{ template.objects[active_object].scale }}</span></label>
                                    <fg-input type="range"
                                              min="0.03" max="5" step="0.005"
                                              label=""
                                              v-model="template.objects[active_object].scale"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label for="control3" class="control-label label-checkbox mb10">По центру по
                                            горизонтали</label>
                                        <input @change="setObjectPosition(0.5, null)"
                                               :checked="template.objects[active_object].position_x == 0.5"
                                               id="control3" class="form-check-inline"
                                               type="checkbox">
                                        <div class="clearfix"></div>
                                        <label for="control4" class="control-label label-checkbox mb10">По центру по
                                            вертикали</label>
                                        <input @change="setObjectPosition(null, 0.5)"
                                               :checked="template.objects[active_object].position_y == 0.5"
                                               id="control4" class="form-check-inline"
                                               type="checkbox">
                                    </div>
                                    <fg-input type="text"
                                              label="Поворот объекта (градусы)"
                                              v-model="template.objects[active_object].angle"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group"
                                         v-show="template.objects[active_object].id.indexOf('nocolor') < 0 && !isGifSrc(template.objects[active_object].id)">
                                        <label class="control-label">Цвет: <span class="param-span">{{
                                                template.objects[active_object].color
                                            }}</span></label>
                                        <input type="color" v-model="template.objects[active_object].color">
                                        <div class="color-set">
                                            <span v-for="c in colors" :style="{ backgroundColor: c }"
                                                  :class="{ 'active' : c === template.objects[active_object].color}"
                                                  @click="setObjColor(c)"></span>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="control-label">Анимация</label>
                                        <select v-model="template.objects[active_object].animation_type"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="t in animation_types" v-bind:value="t.id">{{
                                                    t.name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                    <label v-show="template.objects[active_object].animation_type !== 0"
                                           class="control-label">Длительность анимации: <span
                                        class="param-span">{{
                                            template.objects[active_object].animation_duration
                                        }}</span></label>
                                    <fg-input v-show="template.objects[active_object].animation_type !== 0" type="range"
                                              min="0" max="20" step="0.1"
                                              label=""
                                              v-model="template.objects[active_object].animation_duration"
                                              placeholder="">
                                    </fg-input>

                                    <label class="control-label">Видимость: <span
                                        class="param-span">{{ template.objects[active_object].alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.objects[active_object].alpha"
                                              placeholder="">
                                    </fg-input>

                                    <label for="shadow-color">Цвет тени:</label>
                                    <input type="color" id="shadow-color"
                                           v-model="template.objects[active_object].shadow_color">
                                    <div class="clearfix"></div>
                                    <label class="control-label">Радиус размытия тени: <span
                                        class="param-span">{{ template.objects[active_object].shadow_blur }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="100" step="1"
                                              label=""
                                              v-model="template.objects[active_object].shadow_blur"
                                              placeholder="">
                                    </fg-input>
                                    <label class="control-label">Видимость тени: <span
                                        class="param-span">{{ template.objects[active_object].shadow_alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.objects[active_object].shadow_alpha"
                                              placeholder="">
                                    </fg-input>

                                    <fg-input type="text"
                                              label="Z-индекс"
                                              v-model="template.objects[active_object].z_index"
                                              placeholder="">
                                    </fg-input>

                                    <button type="button" class="btn btn-remove"
                                            @click="removeObject(active_object)">Удалить объект
                                    </button>
                                    <div class="clearfix"></div>

                                </div>

                                <div class="col-md-8">
                                    <div id="preview-container" v-if="template">
                                        <div id="player">
                                            <video ref="videoContainer"
                                                   controls disablepictureinpicture
                                                   muted
                                                   controlsList="nofullscreen nodownload noremoteplayback noplaybackrate"
                                                   playsinline id="video_player"
                                                   style="max-width: 100%; cursor: pointer;">
                                                <source v-bind:src="template.preview_src_full"/>
                                            </video>
                                            <div v-for="(tt, index) in template.texts"
                                                 ref="draggableContainer" class="draggable-container"
                                                 v-if="tt.font_size"
                                                 v-bind:id="`${index}`">
                                                <div v-show="tt.is_visible === 1" class="draggable-header" v-if="fonts.length > 1"
                                                     v-html="text_html(index)" @mousedown="dragMouseDown">
                                                </div>
                                            </div>
                                            <div v-for="(tt, index) in template.objects"
                                                 ref="draggableContainer2" class="draggable-container" v-if="tt.scale"
                                                 v-bind:id="`o${index}`">
                                                <div v-if="tt.id.indexOf('.svg') > 0" v-show="tt.is_visible === 1" class="draggable-header nospace"
                                                     v-html="object_html(index)" @mousedown="dragMouseDown">
                                                </div>
                                                <div v-if="tt.id.indexOf('.svg') < 0" v-show="tt.is_visible === 1" class="draggable-header nospace"
                                                     v-html="image_html(index)" @mousedown="dragMouseDown">
                                                </div>
                                            </div>
                                        </div>

                                        <button type="button" class="btn btn-toggle"
                                                v-bind:class="{ 'active-state': template.src_full }"
                                                @click.prevent="showPreview()">
                                            Показать превью
                                        </button>
                                    </div>

                                </div>


                            </div>

                            <div class="clearfix"></div>
                        </form>
                    </card>
                </div>
                <div class="col-md-3">
                    <card>
                        <h4 slot="header" class="card-title">Параметры видео</h4>
                        <div class="loader" v-if="waiting"></div>

                        <form v-if="template">
                            <div class="row">

                                <div class="col-md-12">
                                    <fg-input type="text"
                                              @input="formatVideoDuration($event)"
                                              label="Длительность, сек."
                                              v-model="template.duration"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Количество фрагментов"
                                              @input="changeVideoCount"
                                              v-model="template.videos"
                                              placeholder="">
                                    </fg-input>
                                    <h4 slot="header" class="card-title">Фрагменты <br>(длительность:
                                        <span v-if="Math.abs(sumParts - template.duration) > 0.05"
                                              class="bg-danger">{{ sumParts }}</span>
                                        <span v-else>{{ sumParts }}</span>):
                                    </h4>


                                    <div class="content" v-for="(itm,index) in client_parts" :key="index">
                                        <div class="control">
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <span class="block-number">{{ index + 1 }}.</span>
                                                </div>
                                                <div class="col-md-3">
                                                    <fg-input type="text"
                                                              @input="formatDuration($event, index)"
                                                              v-bind:label="`Длительн.`"
                                                              v-model="client_parts[index].duration"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                                <div class="col-md-2">
                                                    <fg-input type="text"
                                                              @input="formatSpeed($event, index)"
                                                              v-bind:label="`Скорость`"
                                                              v-model="client_parts[index].speed"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label class="control-label">Эффект</label>
                                                        <select v-model="client_parts[index].effect_type"
                                                                @change="changeEffectType(index, client_parts[index].effect_type)"
                                                                id="category-control"
                                                                aria-describedby="addon-right addon-left"
                                                                class="form-control">
                                                            <option v-for="e in effect_types" v-bind:value="e.id">
                                                                {{ e.name }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

<!--                                            888-->
                                            <div class="row"
                                                 v-bind:class="{ bordered: client_parts[index].effect_type === 0 }">
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <button type="button" class="btn btn-text btn-fill active control-btn collage-btn"
                                                                @click="showCollageModal(index)">Коллаж +
                                                        </button>
                                                    </div>
                                                </div>

                                                <div class="col-md-3" v-if="client_parts[index].collage_type">
                                                    <fg-input type="text"
                                                              @input="formatStartTime($event, index, 'start_time')"
                                                              v-bind:label="`Время начала`"
                                                              v-model="client_parts[index].start_time"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label class="control-label">Тип контента</label>
                                                        <select v-model="client_parts[index].content_type"
                                                                id="category-control"
                                                                aria-describedby="addon-right addon-left"
                                                                class="form-control">
                                                            <option v-for="c in content_types" v-bind:value="c.id">
                                                                {{ c.name }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row bordered"
                                                 v-if="client_parts[index].collage_type">

                                                <div class="col-md-3">
                                                    <div v-html="renderCollagePart(client_parts[index].collage_type)"
                                                         @click="showCollageModal(index)"
                                                         class="collage-preview">
                                                    </div>
                                                    <!--                                                    888-->
                                                </div>
                                                <div class="col-md-3"></div>
                                                <div class="col-md-6">
                                                    <button type="button" class="btn btn-danger btn-fill btn-delete-collage"
                                                            @click.prevent="removeCollageFromPart(index)">Удалить коллаж
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="row bordered"
                                                 v-if="(client_parts[index].effect_type === 1 || client_parts[index].effect_type === 2) && client_parts[index].effect_values">
                                                <div class="effect-values">
                                                    {{ effect_types[client_parts[index].effect_type].name }} - Параметры
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="effect-preview"
                                                         @click="changeEffectPosition($event, index)">
                                                        <span class="effect-area"
                                                              :style="{'top': client_parts[index].effect_values.y * 87 - 15 + 'px',
                                                                        'left': client_parts[index].effect_values.x * 48 - 15 + 'px'}">
                                                            <span class="effect-center"></span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <fg-input type="number" step=0.1
                                                              v-bind:label="`#` + String(index + 1) + ` - Начальное значение`"
                                                              v-model="client_parts[index].effect_values.from"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                                <div class="col-md-4">
                                                    <fg-input type="number" step=0.1
                                                              v-bind:label="`#` + String(index + 1) + ` - Конечное значение`"
                                                              v-model="client_parts[index].effect_values.to"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>


                            </div>


                        </form>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

const _ = require('lodash')

const moment = require('moment')
import Card from 'src/components/UIComponents/Cards/Card.vue'
import {template} from "lodash";
import replaceGraphicSize from 'src/mixins/replaceGraphicSize'
import gifGraphic from 'src/mixins/gifGraphic'

export default {
    name: 'EditCategory',
    mixins: [replaceGraphicSize, gifGraphic],
    components: {
        Card,
    },
    data() {
        return {
            id: null,
            showP: false,
            token: localStorage.getItem('token'),
            template: null,
            activeVideo: '',
            waiting: false,
            interval: null,
            lock_waiting: false,
            is_playing: false,
            show_svg_modal: false,
            show_collage_modal: false,
            is_object_changing: false,
            video: null,
            categories: JSON.parse(localStorage.getItem('categories')),
            sizes: JSON.parse(localStorage.getItem('sizes')),
            compression: false,
            preview: null,
            source: null,
            client_parts: [],
            is_text_active: false,
            active_text: 0,
            active_object: 0,
            draggable_index: 0,
            draggable_type: null,
            active_type: 'text',
            server_effects: [],
            server_graphics: [],
            server_filters: [],
            server_fonts: [],
            active_object_category: 'Arrows',
            active_collage_category: '2',
            default_text: {
                text: 'Default text',
                font_name: 'SF Pro',
                font_size: 30,
                text_color: "#ffffff",
                letter_spacing: 0,
                line_spacing: 0,
                alpha: 1,
                text_align: 'center',
                background_color: 'transparent',
                position_x: 0.49,
                position_y: 0.49,
                is_text_brush: 0,
                text_brush_data: [],
                z_index: 1,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                angle: 0,
                direction: 'normal',
                animation_type: 0,
                animation_duration: 0,
                shadow_blur: 0,
                shadow_alpha: 0,
                shadow_color: '#ffffff',
                stroke_size: 0,
                stroke_color: '#000000',
            },
            default_object: {
                id: "b-330x298.svg",
                scale: 1,
                source: '<span>SVG</span>',
                color: '#ffffff',
                alpha: 1,
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                time_start: 0,
                animation_type: 0,
                animation_duration: 0,
                time_end: "",
                is_visible: 1,
                angle: 0,
                shadow_color: '#ffffff',
                shadow_alpha: 0,
                shadow_blur: 0,
            },
            texts: [],
            objects: [],
            colors: [
                "#FFFFFF",
                "#000000",
                "#F9F7F4",
                "#FAF5ED",
                "#F2E8DD",
                "#F4E4DD",
                "#D9BEBD",
                "#C5AEB6",
                "#E3C2D2",
                "#F1E0EF",
                "#D5C9E9",
                "#C8ACE0",
                "#E06E97",
                "#E64F3C",
                "#AB613E",
                "#B97959",
                "#D99056",
                "#E8BF88",
                "#EDD8AB",
                "#FAE389",
                "#F5C154",
                "#B78C3A",
                "#585B3B",
                "#7B7C41",
                "#BBB595",
                "#DFE7DA",
                "#C0DED3",
                "#B4C5C9",
                "#C9D9F0",
                "#4E63EC",
                "#4F5E8D",
                "#725B6E",
                "#F0F0F0",
                "#D9D9D9",
                "#616161",
                "#3C3C3C",
            ],
            fonts: [
                {
                    params: "'SF Pro', sans-serif;",
                    code: "SF Pro",
                    name: "SF Pro",
                },
            ],
            animation_types: [
                {
                    id: 0,
                    name: "-",
                },
                {
                    id: 1,
                    name: "Fade",
                },
                {
                    id: 4,
                    name: "Zoom In",
                },
                {
                    id: 18,
                    name: "Zoom Out",
                },
                {
                    id: 6,
                    name: "Reveal ↓",
                },
                {
                    id: 7,
                    name: "Reveal ↑",
                },
                {
                    id: 8,
                    name: "Reveal →",
                },
                {
                    id: 9,
                    name: "Reveal ←",
                },
                {
                    id: 10,
                    name: "Float ↓",
                },
                {
                    id: 11,
                    name: "Float ↑",
                },
                {
                    id: 12,
                    name: "Float →",
                },
                {
                    id: 13,
                    name: "Float ←",
                },
                {
                    id: 14,
                    name: "Typewriter",
                },
                {
                    id: 15,
                    name: "Typewriter Fade In",
                },
                {
                    id: 16,
                    name: "Typewriter By Word",
                },
                {
                    id: 17,
                    name: "Typewriter By Word Fade In",
                },
            ],
            effect_types: [
                {
                    id: 0,
                    name: "-",
                },
                {
                    id: 1,
                    name: "Zoom in",
                },
                {
                    id: 2,
                    name: "Zoom out",
                },
            ],
            content_types: [
                {
                    id: 0,
                    name: "Любой",
                },
                {
                    id: 1,
                    name: "Фото",
                },
                {
                    id: 2,
                    name: "Видео",
                },
            ],
            text_aligns: [
                {
                    name: "center",
                },
                {
                    name: "start",
                },
                {
                    name: "end",
                },

            ],
            default_positions: {
                clientX: undefined,
                clientY: undefined,
                movementX: 0,
                movementY: 0
            },
            positions: [],
            object_positions: [],
            collages: [
                {
                    name: '2',
                    data: [
                        {
                            id: '2_1',
                            frames: [
                                { x: 0, y: 0, width: 1.0, height: 0.5 },
                                { x: 0, y: 0.5, width: 1.0, height: 0.5 },
                            ],
                        },
                        {
                            id: '2_2',
                            frames: [
                                { x: 0, y: 0, width: 1.0, height: 0.491 },
                                { x: 0, y: 0.509, width: 1.0, height: 0.491 },
                            ],
                        },
                        {
                            id: '2_3',
                            frames: [
                                { x: 0.0306, y: 0.0177, width: 0.9388, height: 0.474 },
                                { x: 0.0306, y: 0.5083, width: 0.9388, height: 0.474 },
                            ],
                        },
                        {
                            id: '2_4',
                            frames: [
                                { x: 0.0306, y: 0.0177, width: 0.9388, height: 0.474, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.0306, y: 0.5083, width: 0.9388, height: 0.474, crop: { type: 'roundedCorner', value: 0.027 } },
                            ],
                        },
                        {
                            id: '2_5',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 1.0 },
                                { x: 0.5, y: 0, width: 0.5, height: 1.0 },
                            ],
                        },
                        {
                            id: '2_6',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.315 },
                                { x: 0, y: 0.315, width: 1, height: 0.685 },
                            ],
                        },
                        {
                            id: '2_7',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.685 },
                                { x: 0, y: 0.685, width: 1, height: 0.315 },
                            ],
                        },
                        {
                            id: '2_8',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.5 },
                                { x: 0.5, y: 0.5, width: 0.5, height: 0.5 },
                            ],
                        },
                        {
                            id: '2_9',
                            frames: [
                                { x: 0.2375, y: 0.1223, width: 0.532, height: 0.3647 },
                                { x: 0.2375, y: 0.5133, width: 0.532, height: 0.3647 },
                            ],
                        },
                    ],
                },
                {
                    name: '3',
                    data: [
                        {
                            id: "3_1",
                            frames: [
                                {x: 0, y: 0, width: 1, height: 0.3333},
                                {x: 0, y: 0.3333, width: 1, height: 0.3334},
                                {x: 0, y: 0.6667, width: 1, height: 0.3333},
                            ],
                        },
                        {
                            id: "3_2",
                            frames: [
                                {x: 0, y: 0, width: 1, height: 0.326783},
                                {x: 0, y: 0.336758, width: 1, height: 0.326783},
                                {x: 0, y: 0.673216, width: 1, height: 0.326783},
                            ],
                        },
                        {
                            id: "3_3",
                            frames: [
                                {x: 0.028, y: 0.015625, width: 0.944, height: 0.3125},
                                {x: 0.028, y: 0.34375, width: 0.944, height: 0.3125},
                                {x: 0.028, y: 0.671875, width: 0.944, height: 0.3125},
                            ],
                        },
                        {
                            id: "3_4",
                            frames: [
                                {
                                    x: 0.028,
                                    y: 0.015625,
                                    width: 0.944,
                                    height: 0.3125,
                                    crop: {type: "roundedCorner", value: 0.027}
                                },
                                {
                                    x: 0.028,
                                    y: 0.34375,
                                    width: 0.944,
                                    height: 0.3125,
                                    crop: {type: "roundedCorner", value: 0.027}
                                },
                                {
                                    x: 0.028,
                                    y: 0.671875,
                                    width: 0.944,
                                    height: 0.3125,
                                    crop: {type: "roundedCorner", value: 0.027}
                                },
                            ],
                        },
                        {
                            id: "3_5",
                            frames: [
                                {x: 0, y: 0, width: 0.5, height: 0.3333},
                                {x: 0.5, y: 0.3333, width: 0.5, height: 0.3333},
                                {x: 0, y: 0.6667, width: 0.5, height: 0.3333},
                            ],
                        },
                        {
                            id: "3_6",
                            frames: [
                                {x: 0, y: 0, width: 0.3333, height: 1},
                                {x: 0.3333, y: 0, width: 0.3333, height: 1},
                                {x: 0.6667, y: 0, width: 0.3333, height: 1},
                            ],
                        },
                        {
                            id: "3_7",
                            frames: [
                                {x: 0, y: 0, width: 1, height: 0.5},
                                {x: 0, y: 0.5, width: 0.5, height: 0.5},
                                {x: 0.5, y: 0.5, width: 0.5, height: 0.5},
                            ],
                        },
                        {
                            id: "3_8",
                            frames: [
                                {x: 0, y: 0.5, width: 1, height: 0.5},
                                {x: 0, y: 0, width: 0.5, height: 0.5},
                                {x: 0.5, y: 0, width: 0.5, height: 0.5},
                            ],
                        },
                        {
                            id: "3_9",
                            frames: [
                                {x: 0, y: 0, width: 0.5, height: 0.5},
                                {x: 0.5, y: 0, width: 0.5, height: 0.5},
                                {x: 0, y: 0.5, width: 0.5, height: 0.5},
                            ],
                        },
                        {
                            id: "3_10",
                            frames: [
                                {x: 0.0648, y: 0.064, width: 0.4815, height: 0.28125},
                                {x: 0.0648, y: 0.35925, width: 0.4815, height: 0.28125},
                                {x: 0.0648, y: 0.6564, width: 0.4815, height: 0.28125},
                            ],
                        },
                    ]
                },
                {
                    name: '4',
                    data: [
                        {
                            id: "4_1",
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.25 },
                                { x: 0, y: 0.25, width: 1, height: 0.25 },
                                { x: 0, y: 0.5, width: 1, height: 0.25 },
                                { x: 0, y: 0.75, width: 1, height: 0.25 },
                            ],
                        },
                        {
                            id: "4_2",
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.24267 },
                                { x: 0, y: 0.25264333, width: 1, height: 0.24267 },
                                { x: 0, y: 0.50498666, width: 1, height: 0.24267 },
                                { x: 0, y: 0.75733, width: 1, height: 0.24267 },
                            ],
                        },
                        {
                            id: "4_3",
                            frames: [
                                { x: 0.028, y: 0.015925, width: 0.944, height: 0.23016875 },
                                { x: 0.028, y: 0.26201875, width: 0.944, height: 0.23016875 },
                                { x: 0.028, y: 0.5081125, width: 0.944, height: 0.23016875 },
                                { x: 0.028, y: 0.75420625, width: 0.944, height: 0.23016875 },
                            ],
                        },
                        {
                            id: "4_4",
                            frames: [
                                { x: 0.028, y: 0.015925, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } },
                                { x: 0.028, y: 0.26201875, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } },
                                { x: 0.028, y: 0.5081125, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } },
                                { x: 0.028, y: 0.75420625, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } },
                            ],
                        },
                        {
                            id: "4_5",
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.5 },
                                { x: 0.5, y: 0, width: 0.5, height: 0.5 },
                                { x: 0, y: 0.5, width: 0.5, height: 0.5 },
                                { x: 0.5, y: 0.5, width: 0.5, height: 0.5 },
                            ],
                        },
                        {
                            id: "4_6",
                            frames: [
                                { x: 0, y: 0, width: 0.49075, height: 0.4948 },
                                { x: 0.50925, y: 0, width: 0.49075, height: 0.4948 },
                                { x: 0, y: 0.5052, width: 0.49075, height: 0.4948 },
                                { x: 0.50925, y: 0.5052, width: 0.49075, height: 0.4948 },
                            ],
                        },
                        {
                            id: "4_7",
                            frames: [
                                { x: 0.0315, y: 0.017708, width: 0.45925, height: 0.410417 },
                                { x: 0.50925, y: 0.017708, width: 0.45927, height: 0.410417 },
                                { x: 0.0315, y: 0.438542, width: 0.45927, height: 0.410417 },
                                { x: 0.50925, y: 0.438542, width: 0.45927, height: 0.410417 },
                            ],
                        },
                        {
                            id: "4_8",
                            frames: [
                                { x: 0.0407, y: 0.022917, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } },
                                { x: 0.5213, y: 0.022917, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } },
                                { x: 0.0407, y: 0.5125, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } },
                                { x: 0.5213, y: 0.5125, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } },
                            ],
                        },
                        {
                            id: "4_9",
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.5 },
                                { x: 0, y: 0.5, width: 0.3333, height: 0.5 },
                                { x: 0.3333, y: 0.5, width: 0.3333, height: 0.5 },
                                { x: 0.6666, y: 0.5, width: 0.3334, height: 0.5 },
                            ],
                        },
                        {
                            id: "4_10",
                            frames: [
                                { x: 0.01852, y: 0.010717, width: 0.96296, height: 0.48381425 },
                                { x: 0.01852, y: 0.50546875, width: 0.30864, height: 0.48411425 },
                                { x: 0.34568, y: 0.50546875, width: 0.30864, height: 0.48411425 },
                                { x: 0.67284, y: 0.50546875, width: 0.30864, height: 0.48411425 },
                            ],
                        },
                        {
                            id: "4_11",
                            frames: [
                                { x: 0.01852, y: 0.010417, width: 0.400926, height: 0.4843745 },
                                { x: 0.437966, y: 0.010417, width: 0.543514, height: 0.4843745 },
                                { x: 0.01852, y: 0.5052085, width: 0.543514, height: 0.4843745 },
                                { x: 0.580554, y: 0.5052085, width: 0.400926, height: 0.4843745 },
                            ],
                        },
                        {
                            id: "4_12",
                            frames: [
                                { x: 0, y: 0, width: 0.49074, height: 0.4895829967 },
                                { x: 0.50926, y: 0, width: 0.49074, height: 0.4895829967 },
                                { x: 0, y: 0.4999996633, width: 1, height: 0.2447917 },
                                { x: 0, y: 0.7552083, width: 1, height: 0.2447917 },
                            ],
                        },
                    ]
                },
                {
                    name: '5',
                    data: [
                        {
                            id: '5_1',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.2 },
                                { x: 0, y: 0.2, width: 1, height: 0.2 },
                                { x: 0, y: 0.4, width: 1, height: 0.2 },
                                { x: 0, y: 0.6, width: 1, height: 0.2 },
                                { x: 0, y: 0.8, width: 1, height: 0.2 },
                            ],
                        },
                        {
                            id: '5_2',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.1875 },
                                { x: 0, y: 0.203125, width: 1, height: 0.1875 },
                                { x: 0, y: 0.40625, width: 1, height: 0.1875 },
                                { x: 0, y: 0.609375, width: 1, height: 0.1875 },
                                { x: 0, y: 0.8125, width: 1, height: 0.1875 },
                            ],
                        },
                        {
                            id: '5_3',
                            frames: [
                                { x: 0.028, y: 0.015825, width: 0.944, height: 0.18095 },
                                { x: 0.028, y: 0.2128, width: 0.944, height: 0.18095 },
                                { x: 0.028, y: 0.409675, width: 0.944, height: 0.18095 },
                                { x: 0.028, y: 0.60605, width: 0.944, height: 0.18095 },
                                { x: 0.028, y: 0.803425, width: 0.944, height: 0.18095 },
                            ],
                        },
                        {
                            id: '5_4',
                            frames: [
                                { x: 0.028, y: 0.015825, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.028, y: 0.2128, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.028, y: 0.409675, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.028, y: 0.60605, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.028, y: 0.803425, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } },
                            ],
                        },
                        {
                            id: '5_5',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0, width: 0.5, height: 0.3333 },
                                { x: 0, y: 0.3333, width: 1, height: 0.3333 },
                                { x: 0, y: 0.6666, width: 0.5, height: 0.3334 },
                                { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 },
                            ],
                        },
                        {
                            id: '5_6',
                            frames: [
                                { x: 0, y: 0, width: 0.3333, height: 1 },
                                { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 },
                                { x: 0.3333, y: 0.3333, width: 0.3333, height: 0.3333 },
                                { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 },
                                { x: 0.6666, y: 0, width: 0.3334, height: 1 },
                            ],
                        },
                        {
                            id: '5_7',
                            frames: [
                                { x: 0, y: 0, width: 0.3333, height: 0.3333 },
                                { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 },
                                { x: 0.6666, y: 0, width: 0.3334, height: 0.3333 },
                                { x: 0, y: 0.3333, width: 1, height: 0.3333 },
                                { x: 0, y: 0.6666, width: 1, height: 0.3334 },
                            ],
                        },
                        {
                            id: '5_8',
                            frames: [
                                { x: 0, y: 0, width: 0.49075, height: 0.4947915 },
                                { x: 0, y: 0.5052085, width: 0.49075, height: 0.4947915 },
                                { x: 0.50927, y: 0, width: 0.49075, height: 0.32638867 },
                                { x: 0.50927, y: 0.33710567, width: 0.49075, height: 0.32608867 },
                                { x: 0.50927, y: 0.67361134, width: 0.49075, height: 0.32638867 },
                            ],
                        },
                        {
                            id: '5_9',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.5 },
                                { x: 0, y: 0.5, width: 0.5, height: 0.5 },
                                { x: 0.5, y: 0, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 },
                            ],
                        },
                        {
                            id: '5_11',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.5 },
                                { x: 0.5, y: 0, width: 0.5, height: 0.5 },
                                { x: 0, y: 0.5, width: 0.3333, height: 0.5 },
                                { x: 0.3333, y: 0.5, width: 0.3333, height: 0.5 },
                                { x: 0.6666, y: 0.5, width: 0.3334, height: 0.5 },
                            ],
                        },
                    ],
                },
                {
                    name: '6',
                    data: [
                        {
                            id: '6_1',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.16697 },
                                { x: 0, y: 0.16637, width: 1, height: 0.16697 },
                                { x: 0, y: 0.33304, width: 1, height: 0.16697 },
                                { x: 0, y: 0.49971, width: 1, height: 0.16697 },
                                { x: 0, y: 0.66638, width: 1, height: 0.16696 },
                                { x: 0, y: 0.83304, width: 1, height: 0.16696 },
                            ],
                        },
                        {
                            id: '6_2',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.15798583 },
                                { x: 0, y: 0.16790283, width: 1, height: 0.15798583 },
                                { x: 0, y: 0.33680566, width: 1, height: 0.15798583 },
                                { x: 0, y: 0.50520849, width: 1, height: 0.15798583 },
                                { x: 0, y: 0.67361132, width: 1, height: 0.15798583 },
                                { x: 0, y: 0.84201415, width: 1, height: 0.15798583 },
                            ],
                        },
                        {
                            id: '6_3',
                            frames: [
                                { x: 0.01852, y: 0.01016971, width: 0.96296, height: 0.154152 },
                                { x: 0.01852, y: 0.17500142, width: 0.96296, height: 0.154152 },
                                { x: 0.01852, y: 0.34001313, width: 0.96296, height: 0.154152 },
                                { x: 0.01852, y: 0.50493484, width: 0.96296, height: 0.154152 },
                                { x: 0.01852, y: 0.66985655, width: 0.96296, height: 0.154152 },
                                { x: 0.01852, y: 0.83477826, width: 0.96296, height: 0.154152 },
                            ],
                        },
                        {
                            id: '6_4',
                            frames: [
                                { x: 0.01852, y: 0.01016971, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.01852, y: 0.17500142, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.01852, y: 0.34001313, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.01852, y: 0.50493484, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.01852, y: 0.66985655, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.01852, y: 0.83477826, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                            ],
                        },
                        {
                            id: '6_14',
                            frames: [
                                { x: 0, y: 0, width: 0.1667, height: 1 },
                                { x: 0.1667, y: 0, width: 0.1666, height: 1 },
                                { x: 0.3333, y: 0, width: 0.1667, height: 1 },
                                { x: 0.5, y: 0, width: 0.1667, height: 1 },
                                { x: 0.6667, y: 0, width: 0.1666, height: 1 },
                                { x: 0.8333, y: 0, width: 0.1667, height: 1 },
                            ],
                        },
                        {
                            id: '6_5',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.3333 },
                                { x: 0, y: 0.3333, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 },
                                { x: 0, y: 0.6666, width: 0.3333, height: 0.3334 },
                                { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 },
                                { x: 0.6666, y: 0.6666, width: 0.3333, height: 0.3334 },
                            ],
                        },
                        {
                            id: '6_6',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0, width: 0.5, height: 0.3333 },
                                { x: 0, y: 0.3333, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 },
                                { x: 0, y: 0.6666, width: 0.5, height: 0.3334 },
                                { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 },
                            ],
                        },
                        {
                            id: '6_7',
                            frames: [
                                { x: 0, y: 0, width: 0.49075, height: 0.32638867 },
                                { x: 0.50927, y: 0, width: 0.49075, height: 0.32638867 },
                                { x: 0, y: 0.33685567, width: 0.49075, height: 0.32638867 },
                                { x: 0.50927, y: 0.33685567, width: 0.49075, height: 0.32638867 },
                                { x: 0, y: 0.67321134, width: 0.49075, height: 0.32638867 },
                                { x: 0.50927, y: 0.67321134, width: 0.49075, height: 0.32638867 },
                            ],
                        },
                        {
                            id: '6_8',
                            frames: [
                                { x: 0, y: 0, width: 0.369444, height: 0.25 },
                                { x: 0, y: 0.25, width: 0.369444, height: 0.25 },
                                { x: 0.369444, y: 0, width: 0.630556, height: 0.5 },
                                { x: 0, y: 0.5, width: 0.630556, height: 0.5 },
                                { x: 0.630556, y: 0.5, width: 0.369444, height: 0.25 },
                                { x: 0.630556, y: 0.75, width: 0.369444, height: 0.25 },
                            ],
                        },
                        {
                            id: '6_9',
                            frames: [
                                { x: 0, y: 0, width: 0.369444, height: 0.2421475 },
                                { x: 0, y: 0.2526175, width: 0.369444, height: 0.2421475 },
                                { x: 0, y: 0.505235, width: 0.369444, height: 0.2421475 },
                                { x: 0, y: 0.7578525, width: 0.369444, height: 0.2421475 },
                                { x: 0.387964, y: 0, width: 0.612036, height: 0.4947915 },
                                { x: 0.387964, y: 0.505235, width: 0.612036, height: 0.4947915 },
                            ],
                        },
                        {
                            id: '6_10',
                            frames: [
                                { x: 0, y: 0, width: 0.3333, height: 0.65833 },
                                { x: 0, y: 0.65833, width: 0.3333, height: 0.34167 },
                                { x: 0.3333, y: 0, width: 0.3333, height: 0.34167 },
                                { x: 0.3333, y: 0.34167, width: 0.3333, height: 0.65833 },
                                { x: 0.6666, y: 0, width: 0.3334, height: 0.65833 },
                                { x: 0.6666, y: 0.65833, width: 0.3334, height: 0.34167 },
                            ],
                        },
                        {
                            id: '6_11',
                            frames: [
                                { x: 0, y: 0, width: 0.32098667, height: 0.32638867 },
                                { x: 0.33950667, y: 0, width: 0.32098667, height: 0.32638867 },
                                { x: 0.67851334, y: 0, width: 0.32098667, height: 0.32638867 },
                                { x: 0, y: 0.33685867, width: 0.32098667, height: 0.32638867 },
                                { x: 0, y: 0.67321734, width: 0.32098667, height: 0.32638867 },
                                { x: 0.33950667, y: 0.33685867, width: 0.66049333, height: 0.66314133 },
                            ],
                        },
                        {
                            id: '6_12',
                            frames: [
                                { x: 0, y: 0, width: 0.68611, height: 0.3333 },
                                { x: 0.68611, y: 0, width: 0.31389, height: 0.3333 },
                                { x: 0, y: 0.3333, width: 0.31389, height: 0.3333 },
                                { x: 0.31389, y: 0.3333, width: 0.68611, height: 0.3333 },
                                { x: 0, y: 0.6666, width: 0.68611, height: 0.3334 },
                                { x: 0.68611, y: 0.6666, width: 0.31389, height: 0.3334 },
                            ],
                        },
                        {
                            id: '6_13',
                            frames: [
                                { x: 0.084185, y: 0.14375, width: 0.391667, height: 0.22013867 },
                                { x: 0.522148, y: 0.14375, width: 0.391667, height: 0.22013867 },
                                { x: 0.084185, y: 0.38993067, width: 0.391667, height: 0.22013867 },
                                { x: 0.522148, y: 0.38993067, width: 0.391667, height: 0.22013867 },
                                { x: 0.084185, y: 0.63611134, width: 0.391667, height: 0.22013867 },
                                { x: 0.522148, y: 0.63611134, width: 0.391667, height: 0.22013867 },
                            ],
                        },
                    ],
                },
                {
                    name: '9',
                    data: [
                        {
                            id: '9_1',
                            frames: [
                                { x: 0, y: 0, width: 0.3333, height: 0.3333 },
                                { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 },
                                { x: 0.6666, y: 0, width: 0.3333, height: 0.3333 },
                                { x: 0, y: 0.3333, width: 0.3333, height: 0.3334 },
                                { x: 0.3333, y: 0.3333, width: 0.3333, height: 0.3334 },
                                { x: 0.6666, y: 0.3333, width: 0.3333, height: 0.3334 },
                                { x: 0, y: 0.6666, width: 0.3333, height: 0.3334 },
                                { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 },
                                { x: 0.6666, y: 0.6666, width: 0.3333, height: 0.3334 },
                            ],
                        },
                    ],
                },
                {
                    name: '10',
                    data: [
                        {
                            id: '10_1',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.2 },
                                { x: 0.5, y: 0, width: 0.5, height: 0.2 },
                                { x: 0, y: 0.2, width: 0.5, height: 0.2 },
                                { x: 0.5, y: 0.2, width: 0.5, height: 0.2 },
                                { x: 0, y: 0.4, width: 0.5, height: 0.2 },
                                { x: 0.5, y: 0.4, width: 0.5, height: 0.2 },
                                { x: 0, y: 0.6, width: 0.5, height: 0.2 },
                                { x: 0.5, y: 0.6, width: 0.5, height: 0.2 },
                                { x: 0, y: 0.8, width: 0.5, height: 0.2 },
                                { x: 0.5, y: 0.8, width: 0.5, height: 0.2 },
                            ],
                        },
                        {
                            id: '10_2',
                            frames: [
                                { x: 0, y: 0, width: 0.2, height: 0.5 },
                                { x: 0, y: 0.5, width: 0.2, height: 0.5 },
                                { x: 0.2, y: 0, width: 0.2, height: 0.5 },
                                { x: 0.2, y: 0.5, width: 0.2, height: 0.5 },
                                { x: 0.4, y: 0, width: 0.2, height: 0.5 },
                                { x: 0.4, y: 0.5, width: 0.2, height: 0.5 },
                                { x: 0.6, y: 0, width: 0.2, height: 0.5 },
                                { x: 0.6, y: 0.5, width: 0.2, height: 0.5 },
                                { x: 0.8, y: 0, width: 0.2, height: 0.5 },
                                { x: 0.8, y: 0.5, width: 0.2, height: 0.5 },
                            ],
                        },
                    ],
                },
                {
                    name: '12',
                    data: [
                        {
                            id: '12_1',
                            frames: [
                                { x: 0, y: 0, width: 0.3333, height: 0.25 },
                                { x: 0.3333, y: 0, width: 0.3333, height: 0.25 },
                                { x: 0.6666, y: 0, width: 0.3333, height: 0.25 },

                                { x: 0, y: 0.25, width: 0.3333, height: 0.25 },
                                { x: 0.3333, y: 0.25, width: 0.3333, height: 0.25 },
                                { x: 0.6666, y: 0.25, width: 0.3333, height: 0.25 },

                                { x: 0, y: 0.5, width: 0.3333, height: 0.25 },
                                { x: 0.3333, y: 0.5, width: 0.3333, height: 0.25 },
                                { x: 0.6666, y: 0.5, width: 0.3333, height: 0.25 },

                                { x: 0, y: 0.75, width: 0.3333, height: 0.25 },
                                { x: 0.3333, y: 0.75, width: 0.3333, height: 0.25 },
                                { x: 0.6666, y: 0.75, width: 0.3333, height: 0.25 },
                            ],
                        },
                        {
                            name: '20',
                            data: [
                                {
                                    id: '20_1',
                                    frames: [
                                        { x: 0, y: 0, width: 0.25, height: 0.2 },
                                        { x: 0.25, y: 0, width: 0.25, height: 0.2 },
                                        { x: 0.5, y: 0, width: 0.25, height: 0.2 },
                                        { x: 0.75, y: 0, width: 0.25, height: 0.2 },
                                        { x: 0, y: 0.2, width: 0.25, height: 0.2 },
                                        { x: 0.25, y: 0.2, width: 0.25, height: 0.2 },
                                        { x: 0.5, y: 0.2, width: 0.25, height: 0.2 },
                                        { x: 0.75, y: 0.2, width: 0.25, height: 0.2 },
                                        { x: 0, y: 0.4, width: 0.25, height: 0.2 },
                                        { x: 0.25, y: 0.4, width: 0.25, height: 0.2 },
                                        { x: 0.5, y: 0.4, width: 0.25, height: 0.2 },
                                        { x: 0.75, y: 0.4, width: 0.25, height: 0.2 },
                                        { x: 0, y: 0.6, width: 0.25, height: 0.2 },
                                        { x: 0.25, y: 0.6, width: 0.25, height: 0.2 },
                                        { x: 0.5, y: 0.6, width: 0.25, height: 0.2 },
                                        { x: 0.75, y: 0.6, width: 0.25, height: 0.2 },
                                        { x: 0, y: 0.8, width: 0.25, height: 0.2 },
                                        { x: 0.25, y: 0.8, width: 0.25, height: 0.2 },
                                        { x: 0.5, y: 0.8, width: 0.25, height: 0.2 },
                                        { x: 0.75, y: 0.8, width: 0.25, height: 0.2 },
                                    ],
                                },
                            ],
                        }
                    ],
                }
            ],
        }
    },
    watch: {
        is_playing(val) {
            if (val) {
                this.startInterval()
            } else {
                clearInterval(this.interval);
            }
        },
    },
    created: function () {
        let self = this;
        self.id = this.$route.params.id;

        self.getResources();

        self.get(self.id);

    },
    computed: {
        graphicsUrl() {
            return this.$graphicsUrl
        },
        sumParts() {
            let sum = 0;
            _.map(this.client_parts, (p) => {
                if (!p.cutout_only) {
                    let duration = parseFloat(p.duration);
                    duration = isNaN(duration) ? 0 : duration;

                    // Collages block
                    if (p.collage_type !== 0) {
                        let startTime = parseFloat(p.start_time);
                        startTime = isNaN(startTime) ? 0 : startTime;

                        let collageDuration = startTime + duration;
                        duration = sum > collageDuration ? 0 : collageDuration - sum;
                    }

                    sum += duration;
                }
            })

            return sum.toFixed(2);
        },
        sortedFonts() {
            return _.sortBy(this.fonts, (f) => {
                return f.name;
            });
        },
        versions() {
            const result = []
            const start = 9.0 * 10
            const end = this.$endVersion * 10

            for (let i = start; i <= end; i++) {
                result.push((i / 10).toFixed(1))
            }

            return result
        },
    },
    methods: {
        text_html(index) {
            let textModel = this.template.texts[index];
            let text = _.find(this.fonts, (f) => f.name === textModel.font_name);

            if (!text) {
                alert('Шрифт ' + textModel.font_name + ' не найден. Пожалуйста, замените на другой.');

                text = _.first(this.fonts);
            }

            let line_height = parseFloat(textModel.font_size) + parseFloat(textModel.line_spacing);
            let alpha = textModel.alpha;

            let direction = '';
            if (textModel.direction === 'vertical') {
                direction = '  writing-mode: vertical-rl;\n' +
                    '  text-orientation: upright;\n'
            }

            let offset = 4 / 88 * textModel.font_size;
            let blur = 0.29 * textModel.font_size / 88 * textModel.shadow_blur;
            let shadow = `text-shadow: ${offset}px ${offset}px ${blur}px ${textModel.shadow_color}${this.convertAlphaToHex(textModel.shadow_alpha)};`;

            return '<span style="color: ' + textModel.text_color + '; ' +
                'background-color: ' + textModel.background_color + '; ' +
                'font-size: ' + textModel.font_size + 'px; ' +
                'letter-spacing: ' + textModel.letter_spacing + 'px; ' +
                'opacity: ' + alpha + '; ' +
                'line-height: ' + line_height + 'px; ' +
                'transform: rotate( ' + textModel.angle + 'deg); ' +
                'display: block;' +
                'border: 1px solid white;' +
                'padding: 5px;' +
                direction +
                shadow +
                'text-align: ' + textModel.text_align + '; ' +
                'z-index: ' + textModel.z_index + '; ' +
                'font-family:' + text.params + ';">'
                + textModel.text + '</span>';

        },
        object_html(index) {
            return this.renderSvgObjectHtml(this.template.objects[index]);
        },
        image_html(index) {
            let objectModel = this.template.objects[index];

            if (!objectModel.source || !objectModel.dimensions) {
                return "";
            }

            let width = objectModel.dimensions.width;
            let height = objectModel.dimensions.height;

            width = width * parseFloat(objectModel.scale);
            height = height * parseFloat(objectModel.scale);

            let img = `<img src="${this.objectPlayerSrc(objectModel)}">`;

            let style = ` style="width: ${width}px; height: ${height}px; opacity: ${objectModel.alpha}; padding: 0px; transform: rotate(${objectModel.angle}deg); z-index: ${objectModel.z_index}; display: block;"`;

            img = this.insertAt(img, style, 5)

            return img;
        },
        isVideo: function (url) {
            return url.indexOf('.mp4') > -1;
        },
        goBack: function () {
            window.history.back();
        },
        getResources: function () {
            let self = this;

            axios.get(
                `${this.$hostname}/admin/resources/`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    self.server_effects = response.data.effects;
                    self.server_graphics = response.data.graphics;
                    self.server_filters = response.data.filters;
                    self.server_fonts = response.data.fonts;

                    self.appendFonts();
                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>${error}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },
        insertAt(str, sub, pos) {
            return `${str.slice(0, pos)}${sub}${str.slice(pos)}`;
        },
        formatStartTime(event, index, object) {
            this.client_parts[index][object] = this.client_parts[index][object].replace(',', '.')
        },
        formatDuration(event, index) {
            this.client_parts[index].duration = this.client_parts[index].duration.replace(',', '.')
        },
        formatSpeed(event, index) {
            this.client_parts[index].speed = this.client_parts[index].speed.replace(',', '.')
        },
        formatVideoDuration(event, index) {
            this.template.duration = this.template.duration.replace(',', '.')
        },
        addText(copy = false) {
            let self = this;

            // if copied
            if (copy !== false) {
                let copiedText = JSON.parse(JSON.stringify(self.template.texts[self.active_text]));
                copiedText.text = 'Default text';

                self.template.texts.push(copiedText);

                let positions = self.positions[self.active_text];
                positions.clientX = positions.clientX ? positions.clientX + 5 : positions.clientX;
                positions.clientY = positions.clientY ? positions.clientY + 5 : positions.clientY;
                self.positions.push(JSON.parse(JSON.stringify(positions)));

                setTimeout(() => {

                    self.$refs.draggableContainer[self.template.texts.length - 1].style.left = self.$refs.draggableContainer[self.active_text].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = self.$refs.draggableContainer[self.active_text].offsetTop + 5 + 'px';

                    self.active_text = self.template.texts.length - 1;
                    self.active_type = 'text';

                    //console.log(self.$refs.draggableContainer[self.template.texts.length - 1].style.left);
                }, 100);
            } else {
                self.template.texts.push(JSON.parse(JSON.stringify(self.default_text)));
                self.positions.push(JSON.parse(JSON.stringify(self.default_positions)));

                self.active_text = self.template.texts.length - 1;
                self.active_type = 'text';

            }

        },
        addObject(object, copy = false) {
            let self = this;

            // if copied
            if (copy !== false) {
                let copiedObject = JSON.parse(JSON.stringify(self.template.objects[self.active_object]));

                self.template.objects.push(copiedObject);
                self.object_positions.push(JSON.parse(JSON.stringify(self.object_positions[self.active_object])));

                setTimeout(() => {

                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.left = self.$refs.draggableContainer2[self.active_object].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.top = self.$refs.draggableContainer2[self.active_object].offsetTop + 5 + 'px';

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object'

                }, 100);
            } else {
                self.placeGraphicObject(object);
            }


            self.active_object_category = 'Arrows';

        },
        changeObject() {
            this.is_object_changing = true;
            this.show_svg_modal = true;
        },
        addCollage(e) {
            // 888
            let data = e.target.dataset.params;
            let params = data.split(';');
            let id = params[0];
            let part = params[1]
            let x = params[2]
            let y = params[3]
            let w = params[4]
            let h = params[5]

            this.client_parts[this.active_part_index].collage_type = `${id};${part}`;
            this.client_parts[this.active_part_index].frame = {
                x: parseFloat(x),
                y: parseFloat(y),
                w: parseFloat(w),
                h: parseFloat(h)
            };

            this.previous_collage_id = id;

            this.show_collage_modal = false;
        },
        convertCollageTypeToNewFormat(oldType) {

            if (oldType.toString().indexOf('_') > 0) return oldType;

            let oldTypeName = _.find(this.collage_types, (c) => c.id === parseInt(oldType)).name
            let oldCategory = oldTypeName.split('/');
            let collageCategory = parseInt(oldCategory[1]) === 6 ? 6 : 1;

            return `${oldCategory[1]}_${collageCategory};${oldCategory[0]}`;
        },
        convertAlphaToHex(alpha) {
            if (alpha < 0.08) return '00';
            return Math.floor(alpha * 255).toString(16);
        },
        selectText(text) {
            this.active_text = text;
            this.active_type = 'text';
        },
        selectObject(object) {
            this.active_object = object;
            this.active_type = 'object';
        },
        selectObjectCategory(category) {
            this.active_object_category = category;
        },
        selectCollageCategory(category) {
            this.active_collage_category = category;
        },
        removeCollageFromPart(index) {
            let self = this;

            if (confirm("Подтверждение удаления коллажа")) {
                self.client_parts[index].collage_type = 0;
                self.client_parts[index].frame = null;

                console.log(self.client_parts[index]);
            }

        },
        removeText(index) {
            let self = this;

            if (self.template.texts.length < 2) {
                const notification = {
                    template: `<span><b>Для удаления последнего текста используйте чекбокс "Наложение текста"</b></span>`
                };

                self.$notifications.notify(
                    {
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'warning'
                    })

                return;
            }

            if (confirm("Подтверждение удаления текста: " + self.template.texts[index].text)) {
                self.active_text = 0;
                self.active_type = 'text'

                self.template.texts = self.template.texts.filter((t, i) => i !== index);
            }
        },
        removeObject(index) {
            let self = this;

            if (self.template.objects.length < 2) {
                const notification = {
                    template: `<span><b>Для удаления последнего объекта используйте чекбокс "Наложение текста"</b></span>`
                };

                self.$notifications.notify(
                    {
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'warning'
                    })

                return;
            }

            if (confirm("Подтверждение удаления объекта")) {
                self.active_object = 0;
                self.active_type = 'object'

                self.template.objects = self.template.objects.filter((t, i) => i !== index);
            }
        },
        toggleText() {
            let self = this;

            if (self.is_text_active) {
                self.template.texts.push(JSON.parse(JSON.stringify(self.default_text)));
                self.positions.push(JSON.parse(JSON.stringify(self.default_positions)));

                setTimeout(() => {
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = '0px';

                }, 500);
            } else {
                self.template.texts = [];
                self.positions = [];
            }
        },
        toggleBackground() {
            if (this.template.texts[this.active_text].background_color === 'transparent') {
                this.setColor('#FFFFFF', 'background');
            } else {
                this.setColor('transparent', 'background');
            }
        },
        setTextPosition: function (x, y) {

            x = parseFloat(x);
            y = parseFloat(y);

            if (x) {
                this.template.texts[this.active_text].position_x = x;

                let centerX = 0.5 * 360 - this.$refs.draggableContainer[this.active_text].clientWidth / 2;

                this.$refs.draggableContainer[this.active_text].style.left = centerX + 'px';
            }

            if (y) {
                this.template.texts[this.active_text].position_y = y;

                let centerY = 0.5 * 640 - this.$refs.draggableContainer[this.active_text].clientHeight / 2;

                this.$refs.draggableContainer[this.active_text].style.top = centerY + 'px';
            }
        },
        setObjectPosition: function (x, y) {
            if (x) {
                this.template.objects[this.active_object].position_x = x;

                let centerX = 0.5 * 360 - this.$refs.draggableContainer2[this.active_object].clientWidth / 2;

                this.$refs.draggableContainer2[this.active_object].style.left = centerX + 'px';
            }

            if (y) {
                this.template.objects[this.active_object].position_y = y;

                let centerY = 0.5 * 640 - this.$refs.draggableContainer2[this.active_object].clientHeight / 2;

                this.$refs.draggableContainer2[this.active_object].style.top = centerY + 'px';
            }
        },
        changeContentType: function (index, type) {
            this.client_parts[index].content = type === 2 ? '#000000' : null;
        },
        changeEffectType: function (index, type) {

            if (type === 0) {
                return;
            }

            let from = 1;
            let to = 0.85;
            if (type === 2) {
                from = 0.85;
                to = 1;
            }

            this.client_parts[index].effect_values = {
                from: from,
                to: to,
                x: 0.5,
                y: 0.5
            }

        },
        changeEffectPosition: function (event, index) {
            let offsetX;
            let offsetY;

            if (event.target.className !== 'effect-preview') {
                let parent = event.target.parentElement;
                if (parent.className !== 'effect-preview') {
                    parent = parent.parentElement;

                } else {

                }

                offsetX = 0;
                offsetY = 0;
            } else {
                offsetX = event.offsetX < 0 ? 0 : event.offsetX;
                offsetY = event.offsetY < 0 ? 0 : event.offsetY;
            }

            this.client_parts[index].effect_values.x = (offsetX / 50).toFixed(2);
            if (this.client_parts[index].effect_values.x > 1) {
                this.client_parts[index].effect_values.x = 1;
            }

            this.client_parts[index].effect_values.y = (offsetY / 89).toFixed(2);
            if (this.client_parts[index].effect_values.y > 1) {
                this.client_parts[index].effect_values.y = 1;
            }
        },
        setColor: function (color, type) {
            if (type === 'color') {
                this.template.texts[this.active_text].text_color = color;
            }

            if (type === 'background') {
                this.template.texts[this.active_text].background_color = color;
            }
        },
        setObjColor: function (color) {
            this.template.objects[this.active_object].color = color;
        },
        changeVideoCount(value) {
            let self = this;
            let oldParts = JSON.parse(JSON.stringify(self.client_parts));

            if (isNaN(parseInt(value))) {
                return oldParts;
            }

            let newParts = [];
            for (let i = 0; i < value; i++) {
                newParts.push({
                    duration: '',
                    speed: '1.0',
                    effect_type: 0,
                    content_type: 0,
                    effect_values: {x: 0.5, y: 0.5},
                    collage_type: 0,
                    frame: 0,
                    start_time: 0,
                })
            }

            for (let i = 0; i < oldParts.length; i++) {
                for (let j = 0; j < newParts.length; j++) {
                    if (i === j) {
                        newParts[j] = oldParts[i];
                    }
                }
            }

            this.client_parts = newParts;
        },
        showPreview: function () {
            this.is_playing = false;
            this.checkElementsVisibility(0);
            this.video.load();
        },
        checkElementsVisibility: function (currentTime) {
            let self = this;

            let elements = [self.template.texts, self.template.objects];
            for (let o = 0; o < elements.length; o++) {

                let element = elements[o];
                for (let i = 0; i < element.length; i++) {
                    if (currentTime === 0) {
                        element[i].is_visible = 1;
                    } else {
                        if (parseFloat(element[i].time_start) < currentTime && parseFloat(element[i].time_end) > currentTime) {
                            element[i].is_visible = 1;
                        } else if (parseFloat(element[i].time_start) < currentTime && element[i].time_end === "") {
                            element[i].is_visible = 1;
                        } else {
                            element[i].is_visible = 0;
                        }
                    }
                }
            }
        },
        startInterval: function () {
            let self = this;

            this.interval = setInterval(function () {
                self.checkElementsVisibility(self.video.currentTime);
                if (self.template.duration && self.video.currentTime >= self.template.duration) {
                    self.video.load();
                }
            }, 30)

        },
        get: function (id) {
            let self = this;

            axios.get(
                `${this.$hostname}/admin/created/${this.id}`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(async function (response) {

                    let data = response.data;

                    for (let i = 0; i < data.templates[0].texts.length; i++) {
                        data.templates[0].texts[i].is_visible = 1;
                        if (data.templates[0].texts[i].time_start === undefined) {
                            data.templates[0].texts[i].time_start = 0;
                        }
                        if (data.templates[0].texts[i].time_end === undefined) {
                            data.templates[0].texts[i].time_end = "";
                        }

                        if (!data.templates[0].texts[i].direction) {
                            data.templates[0].texts[i].direction = "normal";
                        }

                        if (!data.templates[0].texts[i].animation_type) {
                            data.templates[0].texts[i].animation_type = 0;
                            data.templates[0].texts[i].animation_duration = 0;
                        }

                        if (!data.templates[0].texts[i].shadow_blur) {
                            data.templates[0].texts[i].shadow_blur = 0;
                        }

                        if (!data.templates[0].texts[i].shadow_alpha) {
                            data.templates[0].texts[i].shadow_alpha = 0;
                        }

                        if (!data.templates[0].texts[i].shadow_color) {
                            data.templates[0].texts[i].shadow_color = '#ffffff';
                        }

                        if (!data.templates[0].texts[i].stroke_size) {
                            data.templates[0].texts[i].stroke_size = 0;
                        }

                        if (!data.templates[0].texts[i].stroke_size) {
                            data.templates[0].texts[i].stroke_color = '#000000';
                        }

                        if (!data.templates[0].texts[i].is_text_brush) {
                            data.templates[0].texts[i].text_brush_data = [];
                        }

                    }

                    for (let i = 0; i < data.templates[0].objects.length; i++) {
                        if (!data.templates[0].objects[i].animation_type) {
                            data.templates[0].objects[i].animation_type = 0;
                            data.templates[0].objects[i].animation_duration = 0;
                        }

                        if (!data.templates[0].objects[i].shadow_blur) {
                            data.templates[0].objects[i].shadow_blur = 0;
                        }

                        if (!data.templates[0].objects[i].shadow_alpha) {
                            data.templates[0].objects[i].shadow_alpha = 0;
                        }

                        if (!data.templates[0].objects[i].shadow_color) {
                            data.templates[0].objects[i].shadow_color = '#ffffff';
                        }
                    }

                    self.template = JSON.parse(JSON.stringify(data.templates[0]));

                    self.template.parts.forEach((p) => {
                        self.client_parts.push({
                            duration: p.duration,
                            speed: p.speed ? p.speed : "1.0",
                            effect_type: p.effect_type ? p.effect_type : 0,
                            content_type: p.content_type ? p.content_type : 0,
                            effect_values: p.effect_values ? p.effect_values : {x: 0.5, y: 0.5},
                            collage_type: p.collage_type ? p.collage_type : 0,
                            frame: p.frame ? p.frame : 0,
                            start_time: p.start_time ? p.start_time : 0,
                        });
                    })

                    if (self.template.release_date) {
                        self.template.release_time = moment(self.template.release_date, moment.DATETIME_LOCAL_MS).format('HH:mm');
                        self.template.release_date = moment(self.template.release_date, moment.DATETIME_LOCAL_MS).format('YYYY-MM-DD');
                    } else {
                        self.template.release_time = '12:00';
                    }

                    if (self.template.song_insta) {
                        self.template.song_insta = 'https://www.instagram.com/reels/audio/' + self.template.song_insta;
                    }

                    if (self.template.song_tiktok) {
                        self.template.song_tiktok = 'https://vm.tiktok.com/' + self.template.song_tiktok;
                    }

                    if (self.template.objects.length < 1) {
                        self.template.objects = [];
                        self.object_positions = [];
                    } else {

                        for (let i = 0; i < self.template.objects.length; i++) {

                            self.object_positions.push(self.default_positions);

                            if (self.template.objects[i].id.indexOf('.svg') > -1) {

                                let dataSource = await axios.get(
                                    `${self.$hostname}/admin/services/graphics/svg/source`,
                                    {
                                        'params': {
                                            url: self.graphicsUrl + self.template.objects[i].id,
                                        },
                                        'headers': {
                                            'Authorization': 'Bearer ' + localStorage.getItem('token')
                                        }
                                    })

                                self.template.objects[i].source = dataSource.data


                            } else {
                                self.template.objects[i].source = "Image"
                                if (self.isGifSrc(self.template.objects[i].id)) {
                                    const size = await self.loadRasterGraphic(self.template.objects[i].id);
                                    if (size && !self.template.objects[i].dimensions) {
                                        self.$set(self.template.objects[i], 'dimensions', size);
                                    }
                                }
                            }


                            setTimeout(() => {

                                self.template.objects[i].is_visible = 1;

                                let centerX = self.template.objects[i].position_x * 360 - self.$refs.draggableContainer2[i].clientWidth / 2;
                                let centerY = self.template.objects[i].position_y * 640 - self.$refs.draggableContainer2[i].clientHeight / 2;

                                self.$refs.draggableContainer2[i].style.left = centerX + 'px';
                                self.$refs.draggableContainer2[i].style.top = centerY + 'px';

                                self.video = self.$refs.videoContainer;

                                self.video.addEventListener("playing", function () {
                                    //console.log('play ' + self.video.currentTime);

                                    self.is_playing = true;
                                });

                                self.video.addEventListener("timeupdate", function () {
                                    self.checkElementsVisibility(self.video.currentTime);
                                });

                                self.video.addEventListener("pause", function () {
                                    //console.log('pause ' + self.video.currentTime);

                                    self.is_playing = false;
                                });


                            }, 500);

                        }

                    }

                    if (self.template.texts.length > 0) {

                        self.is_text_active = true;
                        self.active_text = 0;
                        self.active_type = 'text';

                        for (let i = 0; i < self.template.texts.length; i++) {
                            self.positions.push(self.default_positions);

                            if (!self.template.texts[i].angle) {
                                self.template.texts[i].angle = 0;
                            }

                            setTimeout(() => {

                                let centerX = self.template.texts[i].position_x * 360 - self.$refs.draggableContainer[i].clientWidth / 2;
                                let centerY = self.template.texts[i].position_y * 640 - self.$refs.draggableContainer[i].clientHeight / 2;

                                self.$refs.draggableContainer[i].style.left = centerX + 'px';
                                self.$refs.draggableContainer[i].style.top = centerY + 'px';

                                self.video = self.$refs.videoContainer;

                                self.video.addEventListener("playing", function () {
                                    //console.log('play ' + self.video.currentTime);

                                    self.is_playing = true;
                                });

                                self.video.addEventListener("timeupdate", function () {
                                    self.checkElementsVisibility(self.video.currentTime);
                                });

                                self.video.addEventListener("pause", function () {
                                    //console.log('pause ' + self.video.currentTime);

                                    self.is_playing = false;
                                });


                            }, 500);
                        }


                    }

                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>${error}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },
        appendFonts: function () {

            let newStyle = document.createElement('style');
            for (let i = 0; i < this.server_fonts.length; i++) {
                let font = this.server_fonts[i];

                newStyle.appendChild(document.createTextNode(`
                    @font-face {
                      font-family: '${font.name}';
                      src: url('/static/fonts/${font.src}');
                    }
                    `));

                this.fonts.push({
                    params: `'${font.name}', sans-serif;`,
                    code: font.name,
                    name: font.name,
                })
            }

            document.head.appendChild(newStyle);

        },
        showSVGModal: function () {
            this.show_svg_modal = true;
        },
        closeSVGModal: function (event) {
            if (event && (event.srcElement.className === 'modal-wrapper' ||
                event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_svg_modal = false;
                this.is_object_changing = false;
                this.active_object_category = 'Arrows';
            }
        },
        // 888
        showCollageModal: function (index) {
            this.active_part_index = index;
            this.show_collage_modal = true;
        },
        closeCollageModal: function (event) {
            if (event && (event.srcElement.className === 'modal-wrapper' ||
                event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_collage_modal = false;
            }
        },
        save: function () {
            let self = this;

            let template = JSON.parse(JSON.stringify(this.template));
            template.parts = self.client_parts;

            for (let i = 0; i < template.parts.length; i++) {
                if (template.parts[i].duration === null || template.parts[i].speed === null) {
                    const notification = {
                        template: `<span><b>Проверьте длительность фрагментов видео</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })

                    return false;
                }
            }

            if (template.song_insta) {
                const regex = /(\d{14,22})/gi;
                let match = regex.exec(template.song_insta);

                let reelId = match ? match[0] : null;
                template.song_insta = reelId;

                if (!reelId) {
                    const notification = {
                        template: `<span><b>Проверьте формат ссылки на Reels Audio</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })

                    return false;
                }
            }

            if (template.song_tiktok) {
                let parts = template.song_tiktok.split('/');

                if (parts.length > 3 && parts[3].length > 5) {
                    template.song_tiktok = parts[3];
                } else {

                    const notification = {
                        template: `<span><b>Проверьте формат ссылки на TikTok Audio</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })

                    return false;
                }

            }

            if (Math.abs(self.sumParts - template.duration) > 0.05) {

                const notification = {
                    template: `<span><b>Проверьте длительность фрагментов видео</b></span>`
                };

                self.$notifications.notify(
                    {
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    })

                return false;
            }

            if (this.video) {
                this.video.load();
            }

            self.waiting = true;
//console.log(self.template.texts);
//return false;
            setTimeout(() => {

                if (this.is_text_active) {

                    for (let i = 0; i < self.template.texts.length; i++) {

                        let activeText = template.texts[i];

                        if (activeText.position_x !== 0.5) {
                            let centerX = this.$refs.draggableContainer[i].offsetLeft + this.$refs.draggableContainer[i].clientWidth / 2;

                            activeText.position_x = parseFloat((centerX / 360).toFixed(4));
                        }

                        if (activeText.position_y !== 0.5) {
                            let centerY = this.$refs.draggableContainer[i].offsetTop + this.$refs.draggableContainer[i].clientHeight / 2;

                            activeText.position_y = parseFloat((centerY / 640).toFixed(4));
                        }

                        activeText.letter_spacing = activeText.letter_spacing == "" ? 0 : activeText.letter_spacing;
                        activeText.line_spacing = activeText.line_spacing == "" ? 0 : activeText.line_spacing;
                        activeText.angle = activeText.angle == "" ? 0 : activeText.angle;
                        activeText.z_index = activeText.z_index == "" ? 0 : activeText.z_index;

                        activeText.font_size = parseFloat(activeText.font_size);
                        activeText.alpha = parseFloat(activeText.alpha);
                        activeText.letter_spacing = parseFloat(activeText.letter_spacing);
                        activeText.line_spacing = parseFloat(activeText.line_spacing);
                        activeText.time_start = parseFloat(activeText.time_start);
                        activeText.shadow_alpha = parseFloat(activeText.shadow_alpha);
                        activeText.shadow_blur = parseInt(activeText.shadow_blur);
                        activeText.animation_type = parseInt(activeText.animation_type);
                        activeText.animation_duration = parseFloat(activeText.animation_duration);
                        activeText.angle = parseInt(activeText.angle);
                        activeText.z_index = parseInt(activeText.z_index);
                        activeText.time_end = activeText.time_end === "" ? "" : parseFloat(activeText.time_end);

                        activeText.text_brush_data = activeText.is_text_brush ? activeText.text_brush_data : [];

                        template.texts[i] = activeText;
                    }


                    for (let i = 0; i < self.template.objects.length; i++) {

                        let activeObj = template.objects[i];

                        activeObj.position_x = parseFloat(activeObj.position_x);
                        activeObj.position_y = parseFloat(activeObj.position_y);

                        activeObj.scale = parseFloat(activeObj.scale);
                        activeObj.alpha = parseFloat(activeObj.alpha);
                        activeObj.time_start = parseFloat(activeObj.time_start);
                        activeObj.animation_type = parseInt(activeObj.animation_type);
                        activeObj.animation_duration = parseFloat(activeObj.animation_duration);
                        activeObj.angle = activeObj.angle == "" ? 0 : parseInt(activeObj.angle);
                        activeObj.z_index = activeObj.z_index == "" ? 0 : parseInt(activeObj.z_index);
                        activeObj.time_end = activeObj.time_end === "" ? "" : parseFloat(activeObj.time_end);

                        delete activeObj.source;

                        template.objects[i] = activeObj;
                    }


                } else {
                    template.texts = [];
                    template.objects = [];
                }

                if (!template.is_copyrighted) {
                    template.song_insta = "";
                    template.song_tiktok = "";
                }

                template.release_date = template.release_date + ' ' + template.release_time + ':00';

                axios.post(
                    `${this.$hostname}/admin/created/${this.id}/update`,
                    template,
                    {
                        'headers': {
                            'Authorization': 'Bearer ' + this.token
                        }
                    })
                    .then(function (response) {
                        const notification = {
                            template: `<span><b>Шаблон был успешно изменен</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-explore-2',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'info'
                            })

                        self.waiting = false;

//                    self.$router.push('/templates');
                    })
                    .catch(function (error) {
                        const notification = {
                            template: `<span><b>${error.response.data.message}</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-simple-remove',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'danger'
                            })

                        self.waiting = false;
                    });


            }, 200);


        },
        remove: function () {
            let self = this;

            axios.post(
                `${this.$hostname}/admin/created/${this.id}/delete`,
                this.template,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {
                    const notification = {
                        template: `<span><b>Изображение было успешно удалено</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-explore-2',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'info'
                        });

                    self.$router.push('/memories');
                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })

                });
        },
        uploadFile: function (event, type) {
            let self = this;

            let formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            axios.post(
                `${this.$hostname}/admin/services/file/upload`,
                formData,
                {
                    params: {
                        file_type: type
                    },
                    headers: {
                        'Authorization': 'Bearer ' + this.token,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(function (response) {
                self.waiting = false;

                let data = JSON.parse(JSON.stringify(response.data));

                self.template[data.file_type] = data.url;
                self.template[data.file_type + '_full'] = data.url_full;
                self.template[data.file_type + '_size'] = data.filesize;

                if (self.video) {
                    self.showPreview();
                }
            })
                .catch(function (error) {
                    self.waiting = false;
                    console.log(error);
                });
        },
        dragMouseDown: function (event) {
            event.preventDefault()

            let path = event.composedPath ? event.composedPath() : event.path;
            let id = null;
            _.each(path, (p) => {
                if (p.className === 'draggable-container') {
                    id = p.id;
                }
            })

            if (!id) {
                return;
            }

            if (id.indexOf('o') > -1) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'object';

                this.object_positions[this.draggable_index].clientX = event.clientX
                this.object_positions[this.draggable_index].clientY = event.clientY

                document.onmousemove = this.objectDrag
                document.onmouseup = this.closeDragObject
            } else {
                this.draggable_index = id;
                this.draggable_type = 'text';

                this.positions[this.draggable_index].clientX = event.clientX
                this.positions[this.draggable_index].clientY = event.clientY

                document.onmousemove = this.textDrag
                document.onmouseup = this.closeDragText
            }
        },
        textDrag: function (event) {
            event.preventDefault()

            this.positions[this.draggable_index].movementX = this.positions[this.draggable_index].clientX - event.clientX
            this.positions[this.draggable_index].movementY = this.positions[this.draggable_index].clientY - event.clientY
            this.positions[this.draggable_index].clientX = event.clientX
            this.positions[this.draggable_index].clientY = event.clientY

            this.$refs.draggableContainer[this.draggable_index].style.top =
                (this.$refs.draggableContainer[this.draggable_index].offsetTop
                    - this.positions[this.draggable_index].movementY) + 'px'

            this.$refs.draggableContainer[this.draggable_index].style.left =
                (this.$refs.draggableContainer[this.draggable_index].offsetLeft
                    - this.positions[this.draggable_index].movementX) + 'px'

            let centerX = this.$refs.draggableContainer[this.draggable_index].offsetLeft + this.$refs.draggableContainer[this.draggable_index].clientWidth / 2;
            let centerY = this.$refs.draggableContainer[this.draggable_index].offsetTop + this.$refs.draggableContainer[this.draggable_index].clientHeight / 2;

            this.template.texts[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.texts[this.draggable_index].position_y = parseFloat((centerY / 640).toFixed(4));
        },
        closeDragText() {
            document.onmouseup = null
            document.onmousemove = null

            this.draggable_index = null

            return false;
        },
        objectDrag: function (event) {
            event.preventDefault()

            this.object_positions[this.draggable_index].movementX = this.object_positions[this.draggable_index].clientX - event.clientX
            this.object_positions[this.draggable_index].movementY = this.object_positions[this.draggable_index].clientY - event.clientY
            this.object_positions[this.draggable_index].clientX = event.clientX
            this.object_positions[this.draggable_index].clientY = event.clientY

            this.$refs.draggableContainer2[this.draggable_index].style.top =
                (this.$refs.draggableContainer2[this.draggable_index].offsetTop
                    - this.object_positions[this.draggable_index].movementY) + 'px'

            this.$refs.draggableContainer2[this.draggable_index].style.left =
                (this.$refs.draggableContainer2[this.draggable_index].offsetLeft
                    - this.object_positions[this.draggable_index].movementX) + 'px'

            this.syncObjectModelFromElement(this.draggable_index);
        },
        closeDragObject() {
            document.onmouseup = null
            document.onmousemove = null

            this.draggable_index = null

            return false;
        },
        renderCollagePart(index) {
            let layout = index.split(';');

            if (index) {
                let category = layout[0].split('_')[0];
                let collageId = layout[0];
                let partId = parseInt(layout[1]);
                let collages = _.find(this.collages, (c) => c.name === category)
                let collage = _.find(collages.data, (c) => c.id === collageId)

                return this.renderCollage(collage, 0.7, partId - 1);
            }
        },
        renderCollage(layout, scale = 1, partId = null) {

            let palette = [
                "#FFDFBA","#FFFFBA","#BAFFC9","#BAE1FF",
                "#D7C4F3","#C1F0F6","#FAD6A5","#F7C5CC","#C9E4DE"
            ];

            let containerStyle =
                "position:relative;" +
                `width:${108 * scale}px;height:${192 * scale}px;` +
                "background:#f7f7f7;overflow:hidden;" +
                `border: 1px solid ${partId === null && this.previous_collage_id === layout.id ? 'red' : '#000'};` +
                "box-shadow:0 6px 20px rgba(0,0,0,.08);";

            let html = '<div style="' + containerStyle + '">';

            for (let i = 0; i < layout.frames.length; i++) {
                let f = layout.frames[i];

                let left = f.x * 108 * scale;
                let top = f.y * 192 * scale;
                let width = f.width * 108 * scale;
                let height = f.height * 192 * scale;

                let color = palette[i % palette.length];

                let radiusStyle = "0px";
                if (f.crop && f.crop.type === "roundedCorner") {
                    let v = f.crop.value;
                    if (v < 0) v = 0;
                    if (v > 1) v = 1;
                    radiusStyle = (v * Math.min(width, height) / 2) + "px";
                }

                let frameStyle =
                    "position:absolute;" +
                    "left:" + left + "px;top:" + top + "px;" +
                    "width:" + width + "px;height:" + height + "px;" +
                    "background:" + color + ";" +
                    "border-radius:" + radiusStyle + ";overflow:hidden;" +
                    "display:flex;align-items:center;justify-content:center;" +
                    "color:rgba(0,0,0,.5);" +
                    "font:600 12px sans-serif;";

                let params = `${layout.id};${i + 1};${f.x};${f.y};${f.width};${f.height}`;

                html += `
                          <div
                            data-params="${params}"
                            class="collage-item-part ${partId === i ? 'diagonal-lines' : ''}"
                            style="${frameStyle}"
                          >
                            ${i + 1}
                          </div>
                        `;
            }

            html += "</div>";
            return html;
        },


    }
}

</script>
<style scoped>

@import url('https://fonts.cdnfonts.com/css/sf-pro-display');

.range {
    cursor: pointer !important;
}

#preview-container {
    display: block;
    margin: 0 auto 30px auto;
    width: 360px;
}

.object-preview {
    width: 100px;
    display: block;
    cursor: pointer;
    margin-bottom: 15px;
}

#preview {
    position: relative;
    width: 360px;
    height: 640px;
    overflow: hidden;
    background-size: cover;
    background-position: center;
}

#preview::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.25);
}

#player {
    width: 360px;
    height: 640px;
    position: relative;
    top: 0;
    background: #fff;
    z-index: 11;
    transition: all .3s ease-out;
}

video::-webkit-media-controls-fullscreen-button {
    display: none !important;
}

.btn-toggle {
    width: 360px;
    height: 40px;
    margin: 33px auto;
    background: #000;
    border: none;
    font-size: 15px;
    opacity: 1;
    color: #fff;
}

.btn-toggle:hover {
    opacity: 0.8 !important;
}

.btn-toggle.active-state {
    display: block;
}

.draggable-header {
    white-space: pre;
    cursor: pointer;
    z-index: 10;
}

.draggable-header.nospace {
    white-space: normal;
    padding: 0;
}

.draggable-container {
    top: 0px;
    position: absolute;
    z-index: 9;
}

.text-area {
    width: 100%;
    padding: 8px 12px;
}

.btn-save {
    width: 150px;
}

.btn-info.btn-fill, .btn-info.btn-fill:active {
    color: #54abfe;
    background-color: #FFFFFF;
    border: 1px solid #54abfe;
    margin-top: 8px;
}

.btn-text, .btn-text:active, .btn-text:hover {
    color: #000;
    background-color: #FFFFFF;
    border: 1px solid #000000;
    margin-right: 5px;
    margin-bottom: 5px;
}

.btn-text.active {
    color: #000;
    background-color: #D5C9E9;
    border: 1px solid #D5C9E9;
}

.btn-text:hover {
    opacity: 0.6;
}

.btn-text.control-btn {
    color: #54abfe;
    background-color: #FFFFFF;
    border: 1px solid #54abfe;
    margin-left: 25px;
}

.button-preview {
    height: 20px;
    width: 70px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.button-preview:active {

}

.control-btn:last-child {
    margin-left: 0px;
}

.btn-remove, .btn-remove:active {
    color: rgba(255, 70, 50);
    border: 1px solid rgba(255, 70, 50);
    background-color: transparent;
    margin-top: 20px
}

.btn-delete-collage, .btn-delete-collage:active, .btn-delete-collage:hover, .btn-delete-collage:focus  {
    opacity: 0.5;
    font-size: 12px;
    color: rgba(255, 70, 50);
    border: 1px solid rgba(255, 70, 50);
    background-color: transparent;
    position: absolute;
    bottom: 5px;
    right: 20px;
}

.btn-delete-collage:hover {
    opacity: 0.3;
}

.checkbox-block {
    margin-top: 20px;
    margin-left: 20px;
}


.color-set span {
    width: 37px;
    height: 26px;
    display: inline-block;
    margin-left: 5px;
    border-radius: 5px;
    cursor: pointer;
}

.color-set span:first-child {
    border: 1px solid #E3E3E3;
}

.color-set span.active {
    border: 1px solid #000000;
}
.tags-set {
    margin-top: 8px;
}
.tags-set div {
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 5px;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    border: 1px solid #E3E3E3;
    font-size: 14px;
}
.tags-set div:hover {

}
.tags-set div.active {
    border: 1px solid transparent;
    background-color: #54abfe47;
}

.btn-file {
    display: none;
}

.upload-button {
    margin-top: 10px;
}

.inline-link {
    font-size: 16px;
    margin-left: 5px;
}

.inline-link span, h4 .bg-danger {
    padding: 3px;
    border-radius: 4px;
}

.bg-danger {
    font-size: 16px;
    background-color: rgba(255, 70, 50, 0.5) !important;
}

.image-block {
    max-width: 100%;
}

.form-check-inline {
    display: inline-block;
    cursor: pointer;
}

.label-checkbox {
    margin-right: 10px;
    cursor: pointer;
}

.link {
    cursor: pointer;
    text-decoration: underline;
}

.card-body p {
    font-weight: 300;
    font-style: italic;
}

.card-body form {
    margin-top: 15px;
}

.mb10 {
    margin-bottom: 10px
}

.device-block {
    position: relative;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
}

.device-block img {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 18px;
    top: 18px;
}

.device-block span {
    position: absolute;
    top: -30px;
    left: 5px;
}

.param-span, .param-span label {
    font-size: 0.8rem;
    color: #000;
}

.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 1.7s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 1000px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 1.7s ease;
}


.modal-header h3 {
    margin-top: 0;
    color: #42b983;
}

.modal-header button {
    text-transform: capitalize;
}

.modal-body {
    margin: 20px 0;
    overflow: scroll;
    height: 500px;
}
.collage-item {
    width: 108px;
    height: 192px;
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
}
.collage-btn {
    margin-top: 25px;
    font-size: 12px;
}
.collage-category {
    padding-left: 40px;
    padding-right: 40px;
}

.object-item {
    display: inline-block;
    max-width: 100px;
    height: 64px;
    margin-right: 20px;
    cursor: pointer;
    margin-bottom: 10px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.object-item:first-child {
    margin-left: 0;
}

.object-item:hover {
    opacity: 0.6;
}

.object-item img {
    width: 100%;
    max-height: 64px;
    display: block;
}

.modal-header {
    padding-left: 0;
    display: block;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.texts-buttons button {
    position: relative;
}

.animated-icon {
    font-size: 30px;
    position: absolute;
    color: #6dc030;
    top: -15px;
    right: 0;
}

.effect-values {
    margin-top: 15px;
    display: block;
    width: 100%;
    font-size: 10px;
    text-transform: uppercase;
    margin-left: 15px;
    color: #9A9A9A;
}

.effect-preview {
    width: 50px;
    height: 89px;
    margin-left: 9px;
    display: block;
    border: 1px solid #E3E3E3;
    cursor: pointer;
    position: relative;
}

.effect-area {
    width: 30px;
    height: 30px;
    border: 1px solid #FFD700;
    border-radius: 50%;
    display: block;
    position: relative;
    top: 10px;
    left: 10px
}

.effect-center {
    display: block;
    width: 8px;
    height: 8px;
    background: #FFD700;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    left: 10px;
}
.collage-preview {
    cursor: pointer;
}
.bordered:last-child {
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 15px;
    margin-bottom: 15px;
}

.row {
    margin-right: -13px;
}

.ml9 {
    margin-left: 9px !important;
    margin-bottom: 15px;
}

.block-number {
    display: block;
    margin-top: 0;
    font-size: 38px;
    font-weight: 700;
    color: #000;
}
.realDuration, .partsDuration {
    font-size: 14px;
}
.realDuration span, .partsDuration span {
    font-size: 18px;
}
.btn-delete {
    margin-right: 20px;
    opacity: 0.1;
}
</style>
<style>

.modal-body .collage-item-part:hover {
    opacity: 0.6 !important;
}
.modal-body .collage-item-part:hover {
    position: relative;
    z-index: 0; /* важно, чтобы псевдоэлемент был поверх */
}
.modal-body .collage-item-part:hover::after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none; /* чтобы клики проходили сквозь */
    border-radius: inherit;

    background-image: repeating-linear-gradient(
        45deg,
        transparent,
        transparent 8px,
        rgba(0, 0, 0, 0.8) 9px,
        rgba(0, 0, 0, 0.8) 10px
    );
}

.diagonal-lines {
    position: relative;
    z-index: 0; /* важно, чтобы псевдоэлемент был поверх */
}

.diagonal-lines::after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none; /* чтобы клики проходили сквозь */
    border-radius: inherit;

    background-image: repeating-linear-gradient(
        45deg,
        transparent,
        transparent 8px,
        rgba(0, 0, 0, 0.8) 9px,
        rgba(0, 0, 0, 0.8) 10px
    );
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Memories/Edit.vue